// Sticky add to cart
const addToCartBtn = document.querySelector('.sticky-add-to-cart .single_add_to_cart_button')
const stickyAddToCart = document.querySelector('.sticky-add-to-cart')

document.addEventListener(
    'scroll',
    function () {
        let scrollPosition = window.scrollY

        if (document.body.classList.contains('single-product') && addToCartBtn) {
            if (scrollPosition > 50) {
                if (stickyAddToCart) {
                    stickyAddToCart.style.bottom = '0'
                }
            } else {
                if (stickyAddToCart) {
                    stickyAddToCart.style.bottom = '-5rem'
                }
            }
        }
    },
    {
        passive: true
    }
)
